import axios from 'axios'

export default {
  state: {
    semesters: [],
    semesterData: {}
  },
  mutations: {
    setSemesters(state, payload) {
      state.semesters = payload
    }
  },
  actions: {
    getSemesters({ commit, dispatch, state }, payload) {
      axios.get('/api/semester').then((response) => {
        state.semesters = response.data.semesters
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    getSemesterData({ dispatch, state }, id) {
      axios.get('/api/semester/' + id).then((response) => {
        state.semesterData = response.data.semester
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    addSemester({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/api/semester', payload).then((response) => {
          commit('setSemesters', response.data.semesters)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })  
    },
    updateSemester({ state, commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/semester/' + payload.id, payload).then((response) => {
          state.semesterData = response.data.semester
          commit('setSemesters', response.data.semesters)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setValidationErrors', error)
            reject()
          })
        }) 
      })
    },
    updateNotes({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/semester/' + payload.id + '/notes', payload).then((response) => {
          state.semesterData = response.data.semester
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
          // should add validation here, maybe regex
        })  
      }) 
    }
  },
  getters: {
    activeSemesters(state) {
      return state.semesters.filter(s => s.active)
    },
    semestersRouterFormat(state) { // combine active semesters and routerFormat?
      return state.semesters.map(s => {
        return {
          id: s.id,
          name: s.name,
          slug: s.name.replace(/\s/gi, '-') + '_' + s.id
        }        
      })
    }
  }
}


